module.exports = __webpack_public_path__ + "img/solution1.8758558b.png";